const holdBtn = document.getElementById('on-hold-btn');
const holdModal = document.querySelector('.hold-modal');
const closeModal = document.getElementById('close-hold-modal');

holdBtn?.addEventListener('click', () => {
  holdModal.classList.remove('hideModal');
});

closeModal?.addEventListener('click', () => {
  holdModal.classList.add('hideModal');
});

// Optional: close when clicking outside content
holdModal?.addEventListener('click', (e) => {
  if (e.target.classList.contains('hold-modal-overlay')) {
    holdModal.classList.add('hideModal');
  }
});


